module.exports = __webpack_public_path__ + "static/img/06.0cdbea2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/solution/low-code/06.jpg
// module id = F1nl
// module chunks = 1